// extracted by mini-css-extract-plugin
export default {"container":"BgPurpleBlur_container__3lnuw"};